import React, {Component} from 'react';
import {action, observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import '../Widget/style.scss'
import {
  FormInput,
  Button
} from "shards-react";
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import _ from "underscore";
import {toast} from "react-toastify";
import {reactLocalStorage as Storage} from "reactjs-localstorage";


@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))
@inject(({ widget }) => ({ updateWidget: widget.updateWidget, getWidgetList:widget.getWidgetList, removeWidget:widget.removeWidget }))
@inject(({ common }) => ({ getStoreTotalConfig: common.getStoreTotalConfig, updateDoc: common.updateDoc, getDoc: common.getDoc }))

@observer
class reviewableListWidget extends Component {

  @observable shopUser = {};
  @observable shopInfo = {};
  @observable emailId = '';
  @observable isLogin = false;


  @observable metaWidget = {
    store_id: null,
    reviewableList: "yes",
    reviewableListConfig: {
      pages: [],
      reShowDelay: 24
    }
  };

  @observable selectedPage = "";

  //modals
  @observable modals = {
    isNotiSetting: false
  };

  // 2-11단계: 추가 상태
  @observable previewActiveTab = '';        // 미리보기 페이지 탭
  @observable customDelay = false;          // "직접 입력" 토글
  @observable delayError = '';              // 유효성 메시지
  @observable isGuideOpen = false;          // 가이드 접이식
  @observable showOnboarding = true;        // 온보딩 배너 노출
  @observable isSettingsDirty = false;      // 변경 추적
  @observable isPreviewPulsing = false;     // 미리보기 펄스
  settingsSnapshot = null;
  _beforeUnloadHandler = null;


  //list
  constructor(props) {
    super(props);
    this.init()


  }

  componentDidMount() {
    // 9단계: 페이지 이탈 시 미저장 변경사항 확인
    this._beforeUnloadHandler = (e) => {
      if (this.isSettingsDirty) {
        e.preventDefault();
        e.returnValue = '저장되지 않은 변경사항이 있습니다. 정말 떠나시겠습니까?';
        return e.returnValue;
      }
    };
    window.addEventListener('beforeunload', this._beforeUnloadHandler);

    // 8단계: 온보딩 배너 닫음 여부 (localStorage)
    try {
      if (Storage.get('rwdOnboardingDismissed') === 'true') {
        this.showOnboarding = false;
      }
    } catch (e) {}
  }

  componentWillUnmount() {
    if (this._beforeUnloadHandler) {
      window.removeEventListener('beforeunload', this._beforeUnloadHandler);
    }
  }

  componentDidUpdate(prevProps, prevState){

  }

  @action
  init = async (key) => {
    if(this.props.isLogin) {
      let _this = this;
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.isUse = false;
      if(this.teamUser.isPaidShop) {
        this.isUse = true;
      }
      this.permissions = this.props.me.permissions;

      this.props.getStoreTotalConfig({store_id: this.teamUser.selStore_id, shopNo:this.teamUser.selShopNo ? this.teamUser.selShopNo : 1}, function(res) {
        console.log(res);

        if(res.metaWidget) {
          _this.metaWidget = _.defaults(res.metaWidget, _this.metaWidget);
        }
        // 9단계: 로드 직후 snapshot
        _this.snapshotSettings();
        // 5단계: 표준값 외 값이면 자동으로 직접 입력 모드
        const PRESET_HOURS = [1, 6, 12, 24, 48, 72, 168, 720];
        if (PRESET_HOURS.indexOf(_this.metaWidget.reviewableListConfig.reShowDelay) === -1) {
          _this.customDelay = true;
        }
      });

    }

  };

  // 9단계: snapshot/dirty 헬퍼
  @action
  snapshotSettings = () => {
    this.settingsSnapshot = JSON.stringify({
      reviewableList: this.metaWidget.reviewableList,
      pages: [...(this.metaWidget.reviewableListConfig.pages || [])],
      reShowDelay: this.metaWidget.reviewableListConfig.reShowDelay
    });
    this.isSettingsDirty = false;
  }

  @action
  markDirty = () => {
    this.isSettingsDirty = true;
    // 미리보기 펄스 트리거
    this.isPreviewPulsing = true;
    setTimeout(() => { this.isPreviewPulsing = false; }, 600);
  }

  // 3단계: 토글 + 변경 추적
  @action
  setReviewableList = (value) => {
    this.metaWidget.reviewableList = value;
    this.markDirty();
  }

  // 4단계: 페이지 토글
  @action
  togglePage = (key) => {
    const pages = this.metaWidget.reviewableListConfig.pages;
    if (pages.includes(key)) {
      this.metaWidget.reviewableListConfig.pages = pages.filter(p => p !== key);
    } else {
      pages.push(key);
    }
    // 미리보기 탭 자동 동기화
    if (this.metaWidget.reviewableListConfig.pages.length > 0
        && !this.metaWidget.reviewableListConfig.pages.includes(this.previewActiveTab)) {
      this.previewActiveTab = this.metaWidget.reviewableListConfig.pages[0];
    }
    this.markDirty();
  }

  // 5단계: 재노출 시간
  @action
  setReShowDelay = (hours) => {
    const v = parseInt(hours);
    if (isNaN(v) || v < 1 || v > 720) {
      this.delayError = '1시간 ~ 720시간(30일) 사이로 입력해주세요';
      return;
    }
    this.delayError = '';
    this.metaWidget.reviewableListConfig.reShowDelay = v;
    this.markDirty();
  }

  @action
  toggleCustomDelay = () => {
    this.customDelay = !this.customDelay;
  }

  // 6단계: 미리보기 탭
  @action
  setPreviewTab = (key) => {
    this.previewActiveTab = key;
  }

  // 8단계: 가이드/온보딩
  @action
  toggleGuide = () => {
    this.isGuideOpen = !this.isGuideOpen;
  }

  @action
  dismissOnboarding = () => {
    this.showOnboarding = false;
    try { Storage.set('rwdOnboardingDismissed', 'true'); } catch (e) {}
  }

  // 5단계: 자연어 설명
  formatDelayNatural = (hours) => {
    if (!hours) return '';
    if (hours < 24) return `${hours}시간 후에 다시 표시됩니다`;
    if (hours === 24) return '24시간(1일) 후에 다시 표시됩니다';
    if (hours < 168) return `${hours}시간(약 ${Math.round(hours / 24 * 10) / 10}일) 후에 다시 표시됩니다`;
    if (hours === 168) return '168시간(1주) 후에 다시 표시됩니다';
    if (hours < 720) return `${hours}시간(약 ${Math.round(hours / 24)}일) 후에 다시 표시됩니다`;
    return '720시간(30일) 후에 다시 표시됩니다';
  }


  onChangeInputs = async (event, targetObj) => {
    let { name, value } = event.target;
    console.log(name, value)
    if(name && value){
      if(name === "notiTriggerDelay" || name === "reShowDelay") {
        targetObj[name] = parseInt(value);
      }
      else {
        targetObj[name] = value;
      }
    }
    else {
      targetObj[name] = value;
    }
  };


  updateMetaWidget = async (event, filter) => {

    let updateParams = {
      store_id: this.store._id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1
    };

    for(let i in filter) {
      let key = filter[i];
      updateParams[key] = this.metaWidget[key];
    }

    console.log(updateParams)

    let _this = this;
    this.props.updateDoc('updateMetaWidget', updateParams, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        toast.success('설정이 저장되었습니다.');
        _this.snapshotSettings();
      }
    });
  }

  modalToggle = (type) => {
    this.modals[type] = !this.modals[type];
  }

  addPage = () => {
    if (this.selectedPage && !this.metaWidget.reviewableListConfig.pages.includes(this.selectedPage)) {
      this.metaWidget.reviewableListConfig.pages.push(this.selectedPage);
      this.selectedPage = "";
    }
  }

  removePage = (page) => {
    this.metaWidget.reviewableListConfig.pages = this.metaWidget.reviewableListConfig.pages.filter(p => p !== page);
  }


  render() {
    const isUse = this.metaWidget.reviewableList === 'yes';
    const selectedPages = this.metaWidget.reviewableListConfig.pages || [];
    const PAGE_LABELS = {
      order:   '마이페이지',
      main:    '메인페이지',
      product: '상품 상세페이지'
    };
    const PAGE_ICONS = {
      order:   'user',
      main:    'home',
      product: 'shopping-bag'
    };
    const PAGE_DESCRIPTIONS = {
      order:   '주문 후 리뷰 작성 가능 상품을 노출',
      main:    '쇼핑몰 방문 시 즉시 노출하여 가시성 극대화',
      product: '상품 상세 진입 시 관련 리뷰 작성 유도'
    };
    const PAGE_OPTIONS = [
      {key: 'order',   label: PAGE_LABELS.order,   desc: PAGE_DESCRIPTIONS.order,   icon: PAGE_ICONS.order},
      {key: 'main',    label: PAGE_LABELS.main,    desc: PAGE_DESCRIPTIONS.main,    icon: PAGE_ICONS.main},
      {key: 'product', label: PAGE_LABELS.product, desc: PAGE_DESCRIPTIONS.product, icon: PAGE_ICONS.product},
    ];

    // 5단계: 프리셋
    const PRESET_HOURS = [
      {h: 1,   label: '1시간'},
      {h: 6,   label: '6시간'},
      {h: 12,  label: '12시간'},
      {h: 24,  label: '24시간'},
      {h: 48,  label: '48시간'},
      {h: 72,  label: '72시간'},
      {h: 168, label: '7일'},
      {h: 720, label: '30일'},
    ];

    // 6단계: 미리보기 활성 탭 결정 (선택된 페이지가 1개라도 있으면 첫 번째 또는 사용자 선택)
    let activeTab = this.previewActiveTab;
    if (!selectedPages.includes(activeTab)) {
      activeTab = selectedPages[0] || '';
    }

    // 가짜 상품 미리보기용 데이터 (페이지별로 다르게)
    const PAGE_LAYOUTS = {
      order: { title: '마이페이지 — 주문내역' },
      main:  { title: '쇼핑몰 메인' },
      product: { title: '상품 상세' }
    };

    // 실시간 미리보기 영역 노출 여부 — 추후 다시 활성화 예정
    const SHOW_PREVIEW = false;

    return (
      <div className="main-content reviewable-widget-redesign">
        <PageTitle/>

        {/* === 8단계: 온보딩 힌트 배너 === */}
        {this.showOnboarding && (
          <div className="rwd-onboarding-banner" role="region" aria-label="안내">
            <div className="rwd-onboarding-icon">
              <FeatherIcon icon="zap" size="18" aria-hidden="true" />
            </div>
            <div className="rwd-onboarding-text">
              <strong>리뷰 작성 유도 위젯이란?</strong>
              <p>구매 후 리뷰를 작성하지 않은 고객에게 자동으로 알림 위젯을 띄워 작성을 유도합니다. 노출 페이지와 재노출 시간을 자유롭게 설정할 수 있습니다.</p>
            </div>
            <button type="button" className="rwd-onboarding-close"
                    onClick={() => this.dismissOnboarding()}
                    aria-label="안내 닫기">
              <FeatherIcon icon="x" size="14" aria-hidden="true" />
            </button>
          </div>
        )}

        <div className={`rwd-split ${!SHOW_PREVIEW ? 'rwd-preview-hidden' : ''}`}>

          {/* ============================================================
              좌측: 설정 패널
              ============================================================ */}
          <div className="rwd-settings">
            <div className="rwd-settings-card">
              {/* === 헤더 + 3단계 대형 토글 스위치 === */}
              <div className="rwd-settings-header">
                <div className="rwd-header-icon">
                  <FeatherIcon icon="bell" size="20" aria-hidden="true" />
                </div>
                <div className="rwd-header-text">
                  <p>구매 후 리뷰를 작성하지 않은 고객에게 자동으로 알림 위젯을 노출합니다</p>
                </div>
                <div className="rwd-header-toggle">
                  <button type="button"
                          className={`rwd-big-switch ${isUse ? 'is-on' : ''}`}
                          onClick={() => this.setReviewableList(isUse ? 'no' : 'yes')}
                          role="switch"
                          aria-checked={isUse}
                          aria-label="위젯 사용 여부">
                    <span className="rwd-switch-track">
                      <span className="rwd-switch-thumb" aria-hidden="true" />
                    </span>
                    <span className="rwd-switch-label">{isUse ? 'ON' : 'OFF'}</span>
                  </button>
                </div>
              </div>

              {/* === OFF 시 dim 오버레이 === */}
              <div className={`rwd-form-body ${!isUse ? 'is-dimmed' : ''}`}>
                {!isUse && (
                  <div className="rwd-dim-overlay" aria-hidden="true">
                    <div className="rwd-dim-msg">
                      <FeatherIcon icon="lock" size="20" />
                      <p>위젯을 활성화하면 설정을 변경할 수 있습니다</p>
                    </div>
                  </div>
                )}

                {/* === 4단계: 페이지 카드 그리드 (아이콘 + 이름 + 설명) === */}
                <div className="rwd-section">
                  <div className="rwd-section-header">
                    <FeatherIcon icon="layout" size="14" aria-hidden="true" />
                    <h4>노출 페이지</h4>
                    <span className="rwd-section-help"
                          tabIndex="0"
                          data-tooltip="위젯이 노출될 쇼핑몰 페이지를 선택합니다. 여러 개 선택 가능하며, 다양한 페이지에 노출할수록 작성률이 높아집니다.">
                      <FeatherIcon icon="help-circle" size="13" aria-hidden="true" />
                      <span className="sr-only">노출 페이지 도움말</span>
                    </span>
                  </div>
                  <p className="rwd-section-desc">위젯을 노출할 페이지를 선택해주세요. 카드를 클릭하면 즉시 적용됩니다.</p>

                  <div className="rwd-page-grid">
                    {PAGE_OPTIONS.map(page => {
                      const isSelected = selectedPages.includes(page.key);
                      return (
                        <button key={page.key} type="button"
                                className={`rwd-page-card ${isSelected ? 'is-selected' : ''}`}
                                onClick={() => this.togglePage(page.key)}
                                role="checkbox"
                                aria-checked={isSelected}>
                          <div className="rwd-page-icon">
                            <FeatherIcon icon={page.icon} size="22" aria-hidden="true" />
                          </div>
                          <div className="rwd-page-text">
                            <div className="rwd-page-label">{page.label}</div>
                            <div className="rwd-page-desc">{page.desc}</div>
                          </div>
                          {isSelected && (
                            <div className="rwd-page-check" aria-hidden="true">
                              <FeatherIcon icon="check" size="12" />
                            </div>
                          )}
                        </button>
                      );
                    })}
                  </div>

                  <p className="rwd-page-hint">
                    <FeatherIcon icon="info" size="11" aria-hidden="true" />
                    선택된 페이지에서 리뷰 작성 유도 위젯이 표시됩니다
                  </p>
                </div>

                {/* === 5단계: 닫기 후 재노출 시간 (프리셋 + 자연어) === */}
                <div className="rwd-section">
                  <div className="rwd-section-header">
                    <FeatherIcon icon="clock" size="14" aria-hidden="true" />
                    <h4>닫기 후 재노출 시간</h4>
                    <span className="rwd-section-help"
                          tabIndex="0"
                          data-tooltip="고객이 위젯을 닫은 후 다시 표시되기까지의 시간을 설정합니다. 너무 짧으면 피로감을 주고 너무 길면 작성 기회를 잃습니다. 24~48시간을 권장합니다.">
                      <FeatherIcon icon="help-circle" size="13" aria-hidden="true" />
                      <span className="sr-only">재노출 시간 도움말</span>
                    </span>
                  </div>
                  <p className="rwd-section-desc">사용자가 위젯을 닫은 후 다시 표시되기까지의 시간</p>

                  <div className="rwd-preset-chips" role="radiogroup" aria-label="재노출 시간 프리셋">
                    {PRESET_HOURS.map(p => {
                      const active = !this.customDelay && this.metaWidget.reviewableListConfig.reShowDelay === p.h;
                      return (
                        <button key={p.h} type="button"
                                role="radio"
                                aria-checked={active}
                                className={`rwd-preset-chip ${active ? 'is-active' : ''}`}
                                onClick={() => {
                                  this.customDelay = false;
                                  this.setReShowDelay(p.h);
                                }}>
                          {p.label}
                        </button>
                      );
                    })}
                    <button type="button"
                            className={`rwd-preset-chip rwd-preset-custom ${this.customDelay ? 'is-active' : ''}`}
                            onClick={() => this.toggleCustomDelay()}
                            aria-pressed={this.customDelay}>
                      <FeatherIcon icon="edit-3" size="11" aria-hidden="true" />
                      직접 입력
                    </button>
                  </div>

                  {this.customDelay && (
                    <div className="rwd-delay-input">
                      <FormInput
                        type="number"
                        min="1"
                        max="720"
                        value={this.metaWidget.reviewableListConfig.reShowDelay}
                        onChange={(e) => this.setReShowDelay(e.target.value)}
                        aria-label="재노출 시간(시간 단위, 1~720)"
                        invalid={!!this.delayError}
                      />
                      <span className="rwd-delay-unit">시간 (1~720)</span>
                    </div>
                  )}

                  {this.delayError ? (
                    <div className="rwd-delay-error">
                      <FeatherIcon icon="alert-circle" size="11" aria-hidden="true" />
                      {this.delayError}
                    </div>
                  ) : (
                    <div className="rwd-delay-natural">
                      <FeatherIcon icon="message-square" size="12" aria-hidden="true" />
                      사용자가 위젯을 닫으면 <strong>{this.formatDelayNatural(this.metaWidget.reviewableListConfig.reShowDelay)}</strong>
                    </div>
                  )}
                </div>

                {/* === 8단계: 접이식 가이드 === */}
                <div className="rwd-section rwd-guide-section">
                  <button type="button"
                          className="rwd-guide-toggle"
                          onClick={() => this.toggleGuide()}
                          aria-expanded={this.isGuideOpen}>
                    <FeatherIcon icon="book-open" size="14" aria-hidden="true" />
                    <span>위젯 설정 팁 & 사용 가이드</span>
                    <FeatherIcon icon={this.isGuideOpen ? 'chevron-up' : 'chevron-down'} size="14" aria-hidden="true" />
                  </button>
                  {this.isGuideOpen && (
                    <div className="rwd-guide-body">
                      <div className="rwd-guide-item">
                        <strong>· 추천 페이지 조합</strong>
                        <p>마이페이지 + 메인페이지 조합이 가장 많은 노출과 클릭을 만듭니다. 주문 직후 노출되는 마이페이지 + 재방문 시 노출되는 메인페이지의 시너지가 효과적입니다.</p>
                      </div>
                      <div className="rwd-guide-item">
                        <strong>· 최적의 재노출 시간</strong>
                        <p>대부분의 고객은 24~48시간 이내에 재방문합니다. 너무 짧으면 같은 사용자에게 반복 노출되어 피로감을 주고, 너무 길면 작성 기회를 잃습니다. <strong>24~48시간</strong>을 권장합니다.</p>
                      </div>
                      <div className="rwd-guide-item">
                        <strong>· 위젯이 노출되는 조건</strong>
                        <p>로그인된 회원의 작성 가능 리뷰가 1건 이상일 때 자동으로 노출됩니다. 모든 리뷰를 작성하면 자동으로 사라집니다.</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* === 9단계: Sticky 저장 바 (변경 시 강조) === */}
              <div className={`rwd-actions ${this.isSettingsDirty ? 'is-dirty' : ''}`}>
                {this.isSettingsDirty && (
                  <div className="rwd-dirty-msg">
                    <FeatherIcon icon="alert-circle" size="13" aria-hidden="true" />
                    <span>저장되지 않은 변경사항이 있습니다</span>
                  </div>
                )}
                <Button className="rwd-save-btn" theme="primary"
                        onClick={event => this.updateMetaWidget(event, ["reviewableList", "reviewableListConfig"])}
                        aria-label="설정 저장">
                  <FeatherIcon icon="save" size="14" aria-hidden="true" />
                  {this.isSettingsDirty ? '변경사항 저장' : '설정 저장'}
                </Button>
              </div>
            </div>
          </div>

          {/* ============================================================
              우측: 모바일 미리보기 (6단계: 페이지 전환 탭)
              주의: 추후 다시 활성화될 예정. SHOW_PREVIEW = false 로 임시 숨김.
              ============================================================ */}
          {SHOW_PREVIEW && (
          <div className="rwd-preview">
            <div className="rwd-preview-header">
              <FeatherIcon icon="smartphone" size="14" aria-hidden="true" />
              <strong>실시간 미리보기</strong>
              <span className="rwd-preview-state">
                {isUse ? (
                  <span className="rwd-state-badge rwd-state-on">
                    <span className="rwd-state-dot" />
                    노출 중
                  </span>
                ) : (
                  <span className="rwd-state-badge rwd-state-off">
                    <span className="rwd-state-dot" />
                    비활성
                  </span>
                )}
              </span>
            </div>

            {/* 6단계: 페이지 전환 탭 */}
            {selectedPages.length > 1 && (
              <div className="rwd-preview-tabs" role="tablist" aria-label="미리보기 페이지">
                {selectedPages.map(key => (
                  <button key={key} type="button"
                          role="tab"
                          aria-selected={activeTab === key}
                          className={`rwd-preview-tab ${activeTab === key ? 'is-active' : ''}`}
                          onClick={() => this.setPreviewTab(key)}>
                    <FeatherIcon icon={PAGE_ICONS[key]} size="11" aria-hidden="true" />
                    {PAGE_LABELS[key]}
                  </button>
                ))}
              </div>
            )}

            <div className={`rwd-device ${this.isPreviewPulsing ? 'is-pulsing' : ''}`}>
              <div className="rwd-device-frame">
                <div className="rwd-device-notch" aria-hidden="true" />
                <div className="rwd-device-screen">
                  <div className="rwd-mock-header" aria-hidden="true">
                    <div className="rwd-mock-back">‹</div>
                    <div className="rwd-mock-title">
                      {activeTab && PAGE_LAYOUTS[activeTab] ? PAGE_LAYOUTS[activeTab].title : '쇼핑몰'}
                    </div>
                    <div className="rwd-mock-cart">≡</div>
                  </div>

                  {/* 페이지 유형별 스켈레톤 */}
                  <div className={`rwd-mock-body rwd-mock-${activeTab || 'main'}`} aria-hidden="true">
                    {activeTab === 'order' && (
                      <>
                        <div className="rwd-mock-section-title" />
                        <div className="rwd-mock-order-row"><div className="rwd-mock-image small"/><div className="rwd-mock-lines"><div className="rwd-mock-line"/><div className="rwd-mock-line short"/></div></div>
                        <div className="rwd-mock-order-row"><div className="rwd-mock-image small"/><div className="rwd-mock-lines"><div className="rwd-mock-line"/><div className="rwd-mock-line short"/></div></div>
                        <div className="rwd-mock-order-row"><div className="rwd-mock-image small"/><div className="rwd-mock-lines"><div className="rwd-mock-line"/><div className="rwd-mock-line short"/></div></div>
                      </>
                    )}
                    {activeTab === 'main' && (
                      <>
                        <div className="rwd-mock-banner" />
                        <div className="rwd-mock-products">
                          <div className="rwd-mock-product"><div className="rwd-mock-image"/><div className="rwd-mock-line"/><div className="rwd-mock-line short"/></div>
                          <div className="rwd-mock-product"><div className="rwd-mock-image"/><div className="rwd-mock-line"/><div className="rwd-mock-line short"/></div>
                          <div className="rwd-mock-product"><div className="rwd-mock-image"/><div className="rwd-mock-line"/><div className="rwd-mock-line short"/></div>
                          <div className="rwd-mock-product"><div className="rwd-mock-image"/><div className="rwd-mock-line"/><div className="rwd-mock-line short"/></div>
                        </div>
                      </>
                    )}
                    {activeTab === 'product' && (
                      <>
                        <div className="rwd-mock-image large" />
                        <div className="rwd-mock-line wide" />
                        <div className="rwd-mock-line short" />
                        <div className="rwd-mock-price" />
                        <div className="rwd-mock-line" />
                        <div className="rwd-mock-line" />
                      </>
                    )}
                    {!activeTab && (
                      <>
                        <div className="rwd-mock-banner" />
                        <div className="rwd-mock-products">
                          <div className="rwd-mock-product"><div className="rwd-mock-image"/><div className="rwd-mock-line"/></div>
                          <div className="rwd-mock-product"><div className="rwd-mock-image"/><div className="rwd-mock-line"/></div>
                        </div>
                      </>
                    )}
                  </div>

                  {/* 위젯 시뮬레이션 */}
                  {isUse && selectedPages.length > 0 && (
                    <div className="rwd-widget-overlay" key={activeTab}>
                      <div className="rwd-widget-card">
                        <button type="button" className="rwd-widget-close" aria-label="닫기">×</button>
                        <div className="rwd-widget-title">
                          작성 가능한 리뷰가 <strong>3건</strong> 있어요
                        </div>
                        <div className="rwd-widget-item">
                          <div className="rwd-widget-thumb" aria-hidden="true">
                            <FeatherIcon icon="image" size="18" />
                          </div>
                          <div className="rwd-widget-info">
                            <div className="rwd-widget-name">사랑스러운 하트 롱스푼</div>
                            <div className="rwd-widget-meta">옵션: 화이트 / M</div>
                            <div className="rwd-widget-meta">주문 2025-03-01</div>
                          </div>
                        </div>
                        <button type="button" className="rwd-widget-cta">리뷰 작성하기</button>
                        <div className="rwd-widget-dots" aria-hidden="true">
                          <span className="active" /><span /><span />
                        </div>
                      </div>
                    </div>
                  )}

                  {!isUse && (
                    <div className="rwd-widget-disabled-overlay" aria-hidden="true">
                      <FeatherIcon icon="bell-off" size="36" />
                      <p>위젯이 비활성화되어 있습니다</p>
                    </div>
                  )}
                  {isUse && selectedPages.length === 0 && (
                    <div className="rwd-widget-disabled-overlay" aria-hidden="true">
                      <FeatherIcon icon="layout" size="36" />
                      <p>노출 페이지를 선택하세요</p>
                    </div>
                  )}
                </div>
                <div className="rwd-device-home" aria-hidden="true" />
              </div>

              <div className="rwd-device-caption">
                {isUse && selectedPages.length > 0
                  ? `${selectedPages.map(p => PAGE_LABELS[p]).join(' · ')} 에 노출`
                  : '미리보기'}
              </div>

              {/* 6단계: 외부 링크 버튼 */}
              {this.store && this.store.domain && (
                <a href={this.store.domain.startsWith('http') ? this.store.domain : `https://${this.store.domain}`}
                   target="_blank" rel="noopener noreferrer"
                   className="rwd-external-btn"
                   aria-label="실제 쇼핑몰에서 확인 (새 창)">
                  <FeatherIcon icon="external-link" size="13" aria-hidden="true" />
                  실제 쇼핑몰에서 확인
                </a>
              )}
            </div>
          </div>
          )}
        </div>
      </div>
    )
  }
}

export default reviewableListWidget;
